import React from 'react';
import Navbar from '../Homepage/Navbar';
import Footer from '../Homepage/Footer';
import useLinks from '../../hooks/useLinks';

const MPDI = () => {
    const { mpdi_apply_link } = useLinks();

    return (
        <div className="min-h-screen flex flex-col bg-dark-secondary text-gray-100">
            <Navbar />
            <main className="flex-grow pt-28 pb-20">
                <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">

                    {/* Header Section */}
                    <div className="text-center mb-16">
                        <h1 className="text-3xl md:text-5xl font-extrabold text-white mb-4 tracking-tight leading-tight">
                            Minor in Product Development Internship <span className="text-accent-primary">(MPDI)</span>
                        </h1>
                        <div className="w-32 h-1 bg-gradient-to-r from-accent-primary to-nvcti-orange mx-auto rounded-full"></div>
                        <p className="mt-6 text-gray-400 max-w-3xl mx-auto text-lg">
                            NARESH VASHISHT CENTRE FOR TINKERING AND INNOVATION (NVCTI)<br />
                            INDIAN INSTITUTE OF TECHNOLOGY (INDIAN SCHOOL OF MINES) DHANBAD
                        </p>
                    </div>

                    {/* 1. Objective */}
                    <div className="mb-12">
                        <h2 className="text-2xl md:text-3xl font-bold text-white mb-6 border-l-4 border-nvcti-orange pl-4">1. Objective</h2>
                        <div className="bg-dark-tertiary rounded-3xl p-8 md:p-10 shadow-2xl border border-white/5 transform hover:-translate-y-1 transition-transform duration-300">
                            <p className="text-lg leading-relaxed text-gray-300">
                                To create a dynamic product development ecosystem by engaging students through an
                                internship program focusing on converting innovative ideas into a product or process.
                            </p>
                        </div>
                    </div>

                    {/* 2. Program Details */}
                    <div className="mb-12">
                        <h2 className="text-2xl md:text-3xl font-bold text-white mb-8 border-l-4 border-accent-primary pl-4">2. Program Details</h2>
                        <div className="bg-dark-tertiary rounded-3xl p-8 border border-white/5 mb-8">
                            <ul className="space-y-4">
                                {[
                                    "Academic section of the Institute will run a Minor program in Product Development Internship (MPDI) for the UG students of IIT (ISM). The program will be offered by NVCTI, IIT (ISM) Dhanbad.",
                                    "Eligibility for Minor in MPDI: All UG students of IIT(ISM) Dhanbad who have completed at least two regular semesters in the institute are eligible.",
                                    "The courses under MPDI will be floated in every Summer, Monsoon, and Winter semesters.",
                                    "Minor in MPDI will begin from the date of joining for the program at the start of each semester and continue for a period of maximum 12 months, subject to satisfactory performance.",
                                    "The students will have to register in each of the three semesters (one course in each semester). Each course will be of 9 credits.",
                                    "There will be no registration fee for the course.",
                                    "A student must earn a total of 27 credits in three semesters to obtain the Minor in Product Development Internship in the chosen domain.",
                                    "Students leaving the program early after successful project completion will get a Certificate of Internship but no minor degree.",
                                    "Grades will be awarded but will not be counted towards SGPA and CGPA calculation.",
                                    "Student(s) will have to register for the following courses (one course in each semester in a series) in the above-mentioned program:"
                                ].map((item, idx) => (
                                    <li key={idx} className="flex gap-4 items-start">
                                        <div className="mt-1 min-w-[20px]">
                                            <i className="fas fa-check-circle text-accent-primary text-lg"></i>
                                        </div>
                                        <span className="text-gray-300 leading-relaxed text-lg">{item}</span>
                                    </li>
                                ))}
                            </ul>
                        </div>

                        {/* Merged List of Courses */}
                        <div className="pl-4 border-l-2 border-white/10 ml-2">
                            <h3 className="text-xl font-bold text-white mb-6">List of Courses</h3>
                            <div className="grid lg:grid-cols-3 gap-6">
                                {[
                                    {
                                        series: "Series 1",
                                        color: "border-blue-500",
                                        courses: [
                                            "Internship in Smart Manufacturing-1",
                                            "Internship in Robotic Technology-1",
                                            "Internship in Electronics and IoT-1",
                                            "Internship in Data and Software Technology-1",
                                            "Internship in Animation and Game Design-1",
                                            "Internship in Electric Mobility-1",
                                            "Internship in Finance Technology-1",
                                            "Internship in Aeronautics and Space Technology-1"
                                        ]
                                    },
                                    {
                                        series: "Series 2",
                                        color: "border-purple-500",
                                        courses: [
                                            "Internship in Smart Manufacturing-2",
                                            "Internship in Robotic Technology-2",
                                            "Internship in Electronics and IoT-2",
                                            "Internship in Data and Software Technology-2",
                                            "Internship in Animation and Game Design-2",
                                            "Internship in Electric Mobility-2",
                                            "Internship in Finance Technology-2",
                                            "Internship in Aeronautics and Space Technology-2"
                                        ]
                                    },
                                    {
                                        series: "Series 3",
                                        color: "border-orange-500",
                                        courses: [
                                            "Internship in Smart Manufacturing-3",
                                            "Internship in Robotic Technology-3",
                                            "Internship in Electronics and IoT-3",
                                            "Internship in Data and Software Technology-3",
                                            "Internship in Animation and Game Design-3",
                                            "Internship in Electric Mobility-3",
                                            "Internship in Finance Technology-3",
                                            "Internship in Aeronautics and Space Technology-3"
                                        ]
                                    }
                                ].map((group, idx) => (
                                    <div key={idx} className={`bg-dark-tertiary rounded-2xl p-6 border-t-4 ${group.color} shadow-lg`}>
                                        <h3 className="text-xl font-bold text-white mb-4 pb-2 border-b border-white/10">{group.series}</h3>
                                        <ul className="space-y-3">
                                            {group.courses.map((course, cIdx) => (
                                                <li key={cIdx} className="text-gray-400 text-sm flex items-start gap-2">
                                                    <i className="fas fa-book-open text-xs mt-1 opacity-50"></i>
                                                    {course} <span className="text-xs opacity-50 ml-auto whitespace-nowrap">0-0-9</span>
                                                </li>
                                            ))}
                                        </ul>
                                    </div>
                                ))}
                            </div>
                        </div>
                    </div>

                    {/* 3. Application Process */}
                    <div className="mb-12">
                        <h2 className="text-2xl md:text-3xl font-bold text-white mb-8 border-l-4 border-yellow-500 pl-4">3. Application Process</h2>
                        <div className="bg-dark-tertiary p-8 rounded-3xl border border-white/5">
                            <div className="grid gap-6">
                                <div className="flex gap-4">
                                    <div className="w-12 h-12 rounded-full bg-white/5 flex items-center justify-center shrink-0">
                                        <i className="fas fa-calendar-alt text-yellow-500 text-xl"></i>
                                    </div>
                                    <div>
                                        <h4 className="text-white font-bold text-lg mb-2">Timeline</h4>
                                        <p className="text-gray-400 mb-1">Feb-March (Summer Sem)</p>
                                        <p className="text-gray-400 mb-1">May-June (Monsoon Sem)</p>
                                        <p className="text-gray-400">Nov-Dec (Winter Sem)</p>
                                    </div>
                                </div>
                                <div className="border-t border-white/10 pt-6">
                                    <ul className="space-y-3 text-gray-300">
                                        <li className="flex gap-3"><i className="fas fa-angle-right mt-1 text-yellow-500"></i>Apply in subject areas of Technology Clubs with a project proposal.</li>
                                        <li className="flex gap-3"><i className="fas fa-angle-right mt-1 text-yellow-500"></i>Apply individually or in a team of max 3 students.</li>
                                        <li className="flex gap-3"><i className="fas fa-angle-right mt-1 text-yellow-500"></i>The proposal must be novel, innovative, and original with an undertaking.</li>
                                        <li className="flex gap-3"><i className="fas fa-angle-right mt-1 text-yellow-500"></i>Maximum intake capped at 50 interns per semester.</li>
                                    </ul>
                                </div>
                            </div>
                        </div>
                    </div>

                    {/* 4. Shortlisting Process */}
                    <div className="mb-12">
                        <h2 className="text-2xl md:text-3xl font-bold text-white mb-8 border-l-4 border-red-500 pl-4">4. Shortlisting Process</h2>
                        <div className="grid md:grid-cols-3 gap-6">
                            {[
                                { title: "Endorsement", desc: "Project proposal should be endorsed by a faculty mentor with domain expertise.", icon: "fa-signature" },
                                { title: "Committee Review", desc: "Shortlisted by HoC, FICs of NVCTI, and Club Faculty In-charges.", icon: "fa-users-cog" },
                                { title: "Result Declaration", desc: "On the basis of performance, after continuous evaluation, and recommendation of the competent authority", icon: "fa-bullhorn" }
                            ].map((item, idx) => (
                                <div key={idx} className="bg-dark-tertiary p-6 rounded-2xl text-center border border-white/5 hover:bg-white/5 transition-colors">
                                    <i className={`fas ${item.icon} text-3xl text-red-400 mb-4`}></i>
                                    <h3 className="text-white font-bold text-lg mb-2">{item.title}</h3>
                                    <p className="text-gray-400">{item.desc}</p>
                                </div>
                            ))}
                        </div>
                    </div>

                    {/* 5. Facilities, Stipend & Evaluation */}
                    <div className="mb-12">
                        <h2 className="text-2xl md:text-3xl font-bold text-white mb-8 border-l-4 border-purple-500 pl-4">5. Facilities, Stipend & Evaluation</h2>
                        <div className="bg-gradient-to-br from-dark-tertiary to-purple-900/20 p-8 rounded-3xl border border-white/5">
                            <div className="grid md:grid-cols-2 gap-8">
                                <div>
                                    <h3 className="text-xl font-bold text-purple-400 mb-4 flex items-center gap-2">
                                        <i className="fas fa-tools"></i> Facilities & Support
                                    </h3>
                                    <ul className="space-y-3 text-gray-300">
                                        <li className="flex gap-3"><i className="fas fa-check text-purple-500 mt-1"></i>Access to NVCTI labs and other institute labs (with permission).</li>
                                        <li className="flex gap-3"><i className="fas fa-check text-purple-500 mt-1"></i>Consumables provided by NVCTI as required.</li>
                                    </ul>
                                </div>
                                <div>
                                    <h3 className="text-xl font-bold text-green-400 mb-4 flex items-center gap-2">
                                        <i className="fas fa-money-bill-wave"></i> Stipend
                                    </h3>
                                    <ul className="space-y-3 text-gray-300">
                                        <li className="flex gap-3"><i className="fas fa-check text-green-500 mt-1"></i>INR 6000/month (Regular Semesters).</li>
                                        <li className="flex gap-3"><i className="fas fa-check text-green-500 mt-1"></i>INR 8000/month (Summer Semester with campus stay).</li>
                                        <li className="flex gap-3"><i className="fas fa-info-circle text-green-500 mt-1"></i>Replaced monthly based on satisfactory progress.</li>
                                    </ul>
                                </div>
                            </div>
                            <div className="mt-8 pt-6 border-t border-white/10">
                                <h3 className="text-xl font-bold text-white mb-4">Progress Evaluation</h3>
                                <p className="text-gray-300 leading-relaxed mb-4">
                                    Evaluated monthly by committee. Status: 'Satisfactory' (S) or 'Unsatisfactory' (X).
                                    Students on probation for first 2 months.
                                </p>
                                <div className="bg-red-500/10 border border-red-500/30 p-4 rounded-xl text-red-200 text-sm">
                                    <i className="fas fa-exclamation-triangle mr-2"></i>
                                    <strong>Warning Policy:</strong> 1st Unsatisfactory = Warning. 2nd = Stipend Stopped. 3rd = Termination & "X" Grade.
                                </div>
                            </div>
                        </div>
                    </div>

                    {/* 6. IP & Commercialization */}
                    <div className="mb-8">
                        <h2 className="text-2xl md:text-3xl font-bold text-white mb-8 border-l-4 border-blue-400 pl-4">6. IP & Commercialization</h2>
                        <div className="grid md:grid-cols-2 gap-6">
                            <div className="bg-dark-tertiary p-8 rounded-3xl border border-white/5">
                                <i className="fas fa-rocket text-4xl text-blue-400 mb-6"></i>
                                <h3 className="text-xl font-bold text-white mb-4">Commercialization Support</h3>
                                <p className="text-gray-300">
                                    NVCTI mentors help in commercializing developed products.
                                    Interested inventors are supported to incubate start-ups at the institute’s incubation Center with help in fundraising and scaling.
                                </p>
                            </div>
                            <div className="bg-dark-tertiary p-8 rounded-3xl border border-white/5">
                                <i className="fas fa-copyright text-4xl text-blue-400 mb-6"></i>
                                <h3 className="text-xl font-bold text-white mb-4">Intellectual Property</h3>
                                <p className="text-gray-300">
                                    All Intellectual Property created under the PDI shall belong to IIT (ISM) Dhanbad.
                                    The IPR policy of the institute will be applicable.
                                </p>
                            </div>
                        </div>
                    </div>

                    {/* Apply Now Button - Centered at Bottom */}
                    <div className="mb-16 text-center">
                        <a
                            href={mpdi_apply_link}
                            target="_blank"
                            rel="noopener noreferrer"
                            className="inline-block px-10 py-4 bg-gradient-to-r from-accent-primary to-nvcti-orange text-white text-lg font-bold rounded-full shadow-lg hover:scale-105 transition-transform duration-200"
                        >
                            Apply Now <i className="fas fa-arrow-right ml-2"></i>
                        </a>
                    </div>

                </div>
            </main>
            <Footer />
        </div>
    );
};

export default MPDI;
